module.exports = __webpack_public_path__ + "static/media/brazil.23c03a16.svg";